import React, { useState, useEffect } from "react";
import Form from 'react-bootstrap/Form';
import '../assets/css/home.css';

const HomeSkyCrest8 = () => {
    const [value, setValue] = useState(0);

    const images = [
        "/home_images/00.jpg",
        "/home_images/01.jpg",
        "/home_images/02.jpg",
        "/home_images/03.jpg",
        "/home_images/04.jpg",
        "/home_images/05.jpg",
        "/home_images/06.jpg",
        "/home_images/07.jpg",
        "/home_images/08.jpg",
        "/home_images/09.jpg",
        "/home_images/10.jpg",
        "/home_images/11.jpg",
        "/home_images/12.jpg",
        "/home_images/13.jpg",
        "/home_images/14.jpg",
        "/home_images/15.jpg",
        "/home_images/16.jpg",
        "/home_images/17.jpg",
        "/home_images/18.jpg",
        "/home_images/19.jpg",
        "/home_images/20.jpg",
        "/home_images/21.jpg",
        "/home_images/22.jpg",
        "/home_images/23.jpg",
        "/home_images/24.jpg",
        "/home_images/25.jpg",
        "/home_images/26.jpg",
        "/home_images/27.jpg",
        "/home_images/28.jpg",
        "/home_images/29.jpg",
        "/home_images/30.jpg",
        "/home_images/31.jpg",
        "/home_images/32.jpg",
        "/home_images/33.jpg",
        "/home_images/34.jpg",
        "/home_images/35.jpg",
        "/home_images/36.jpg",
        "/home_images/37.jpg",
        "/home_images/38.jpg",
        "/home_images/39.jpg",
        "/home_images/40.jpg",
        "/home_images/41.jpg",
        "/home_images/42.jpg",
        "/home_images/43.jpg",
        "/home_images/44.jpg",
        "/home_images/45.jpg",
        "/home_images/46.jpg",
        "/home_images/47.jpg",
        "/home_images/48.jpg",
        "/home_images/49.jpg",
        "/home_images/50.jpg",
        "/home_images/51.jpg",
        "/home_images/52.jpg",
        "/home_images/53.jpg",
        "/home_images/54.jpg",
        "/home_images/55.jpg",
        "/home_images/56.jpg",
        "/home_images/57.jpg",
        "/home_images/58.jpg",
        "/home_images/59.jpg",
        "/home_images/60.jpg",
    ];
    useEffect(() => {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);

    return (
        <div className="full-container">
            <img src={`/home_images/${String(value).padStart(2, "0")}.jpg`} alt="" className="home_page_images rotate_view" />
            <div className="home-slider-container">
                <Form.Range min={0} max={60} value={value}
                    onChange={(e) => setValue(e.target.value)} className="home_range_slider" />
            </div>
        </div>
    )
}

export default HomeSkyCrest8;